import { render, staticRenderFns } from "./ProductTagsEdit.vue?vue&type=template&id=a0ec9244&scoped=true&"
import script from "./ProductTagsEdit.vue?vue&type=script&lang=js&"
export * from "./ProductTagsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ec9244",
  null
  
)

export default component.exports